const clientsInfo = {
  vitmark: {
    en: '<b>Vitmark —</b> transport of juices and beverages using refrigerated and curtain-sided trucks. We ensure both export and import operations with full temperature control and comprehensive documentation support.',
    uk: '<b>Вітмарк —</b> транспортування соків та напоїв у рефрижераторах і тентових автомобілях. Забезпечуємо експорт та імпорт продукції з дотриманням температурного режиму й повним документальним супроводом.',
  },
  'logic-up': {
    en: '<b>SBS Group —</b> transport of industrial equipment from Turkey to Ukraine using curtain-sided trucks. We provide efficient customs clearance and reliable logistics for large and heavy cargo.',
    uk: '<b>SBS Group —</b> перевезення промислового обладнання з Туреччини до України у тентових автомобілях. Ми забезпечуємо швидке проходження митних процедур і надійну логістику для великогабаритних вантажів.',
  },
  prodinvest: {
    en: '<b>Prodinvest —</b> export of dairy products to EU countries using refrigerated trucks, in full compliance with veterinary and customs regulations. Logic Up guarantees stable deliveries and top-quality logistics services.',
    uk: '<b>Prodinvest —</b> експорт молочної продукції до країн ЄС у рефрижераторах, з дотриманням усіх ветеринарних і митних вимог. Компанія «Лоджик Ап» гарантує стабільні поставки та бездоганну якість логістичних послуг.',
  },
  dovgan: {
    en: '<b>Dovgan —</b> export of food products to Germany using refrigerated and curtain-sided trucks. We ensure on-time delivery, monitoring of transport conditions, and comprehensive international logistics services.',
    uk: '<b>Довгань —</b> експорт продуктів харчування до Німеччини у рефрижераторах і тентових автомобілях. Забезпечуємо точність у термінах доставки, моніторинг умов транспортування та комплексний міжнародний логістичний сервіс.',
  },
  monolith: {
    en: '<b>Monolith —</b> export of food products to Germany using refrigerated and curtain-sided trucks. We ensure on-time delivery, monitoring of transport conditions, and comprehensive international logistics services.',
    uk: '<b>Моноліт —</b> експорт продуктів харчування до Німеччини у рефрижераторах і тентових автомобілях. Забезпечуємо точність у термінах доставки, моніторинг умов транспортування та комплексний міжнародний логістичний сервіс.',
  },
  milky: {
    en: '<b>Milky —</b> export of dairy products from Ukraine to Bulgaria using refrigerated and curtain-sided vehicles. Our team monitors temperature conditions and provides full logistical support throughout the route.',
    uk: '<b>Milky —</b> експорт молочної продукції з України до Болгарії у рефрижераторах і тентових транспортних засобах. Контролюємо температурний режим і забезпечуємо повну логістичну підтримку на всьому маршруті.',
  },
  kopiyka: {
    en: '<b>Kopiyka —</b> transport of food products in refrigerated and curtain-sided vehicles. Logic Up provides regular import deliveries with controlled storage conditions throughout the entire route.',
    uk: '<b>Копійка —</b> перевезення продуктів харчування у рефрижераторах і тентових автомобілях. Компанія «Лоджик Ап» забезпечує регулярні імпортні постачання з контролем умов зберігання на всьому маршруті.',
  },
  odrex: {
    en: '<b>Odrex —</b> transport of medical equipment with full adherence to safety, packaging, and labeling requirements. Every delivery undergoes strict quality control and comprehensive cargo insurance.',
    uk: '<b>Одрекс —</b> транспортування медичного обладнання з дотриманням усіх вимог безпеки, пакування та маркування. Кожна доставка проходить ретельний контроль і комплексне страхування вантажу.',
  },
  shedro: {
    en: '<b>Schedro —</b> international transport of food products in refrigerated trucks to Eastern European countries. We guarantee stable temperature maintenance, prompt delivery, and compliance with international quality standards.',
    uk: '<b>Щедро —</b> міжнародне перевезення харчової продукції у рефрижераторах до країн Східної Європи. Гарантуємо стабільну температуру, оперативну доставку та відповідність міжнародним стандартам якості.',
  },
};

function getCurrentLang() {
  const html = document.documentElement;
  return html.lang === 'uk' ? 'uk' : 'en';
}

function getClientId(button) {
  const raw = button.getAttribute('aria-label') || '';
  const cleaned = raw.replace(/\s*client\s*$/i, '').trim().toLowerCase();
  return cleaned.replace(/\s+/g, '-');
}

export function setupClientsInfo() {
  const buttons = document.querySelectorAll('.clients__list-button');
  const footerWrapper = document.querySelector('.clients__partner-footer-wrapper');
  let infoBlock = null;
  let activeButton = null;

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const clientId = getClientId(button);
      const lang = getCurrentLang();
      const infoText = clientsInfo[clientId] ? clientsInfo[clientId][lang] : '';

      if (activeButton === button && infoBlock) {
        infoBlock.remove();
        infoBlock = null;
        activeButton = null;
        return;
      }

      if (infoBlock) {
        infoBlock.remove();
        infoBlock = null;
      }

      infoBlock = document.createElement('p');
      infoBlock.className = 'clients__partner-info-block';
      infoBlock.innerHTML = infoText;
      footerWrapper.prepend(infoBlock);
      activeButton = button;
    });
  });
}
